import { IStationData } from "Types/station";

import Icon from "Components/Icon";
import zIndex from "@mui/material/styles/zIndex";

import MobileImg from "Assets/Images/trfficAnalysis/traffic/mobile.svg";
import TruckImg from "Assets/Images/trfficAnalysis/traffic/truck.svg";
import CalltaxiImg from "Assets/Images/trfficAnalysis/traffic/calltaxi.svg";
import TaxiImg from "Assets/Images/trfficAnalysis/traffic/taxi.svg";
import CarImg from "Assets/Images/trfficAnalysis/traffic/car.svg";
import TaxifreeImg from "Assets/Images/trfficAnalysis/traffic/taxifree.svg";
import MobileImgWhite from "Assets/Images/trfficAnalysis/traffic/white/mobile-white.svg";
import TruckImgWhite from "Assets/Images/trfficAnalysis/traffic/white/truck-white.svg";
import CalltaxiImgWhite from "Assets/Images/trfficAnalysis/traffic/white/calltaxi-white.svg";
import TaxiImgWhite from "Assets/Images/trfficAnalysis/traffic/white/taxi-white.svg";
import CarImgWhite from "Assets/Images/trfficAnalysis/traffic/white/car-white.svg";
import TaxifreeImgWhite from "Assets/Images/trfficAnalysis/traffic/white/taxifree-white.svg";
import PollutionImg from "Assets/Images/trfficAnalysis/camera/pollution.svg";
import MortalityImg from "Assets/Images/trfficAnalysis/camera/mortality.svg";
import TrafficImg from "Assets/Images/trfficAnalysis/camera/traffic.svg";
import VegetablesImg from "Assets/Images/trfficAnalysis/camera/vegetables.svg";
import RedlightImg from "Assets/Images/trfficAnalysis/camera/redlight.svg";
import RingImg from "Assets/Images/trfficAnalysis/camera/ring.svg";
import SpeedImg from "Assets/Images/trfficAnalysis/camera/speed.svg";
import LaneImg from "Assets/Images/trfficAnalysis/camera/lane.svg";
import BusImg from "Assets/Images/trfficAnalysis/camera/bus.svg";
import PollutionImgWhite from "Assets/Images/trfficAnalysis/camera/white/pollution-white.svg";
import MortalityImgWhite from "Assets/Images/trfficAnalysis/camera/white/mortality-white.svg";
import TrafficImgWhite from "Assets/Images/trfficAnalysis/camera/white/traffic-white.svg";
import VegetablesImgWhite from "Assets/Images/trfficAnalysis/camera/white/vegetables-white.svg";
import RedlightImgWhite from "Assets/Images/trfficAnalysis/camera/white/redlight-white.svg";
import RingImgWhite from "Assets/Images/trfficAnalysis/camera/white/ring-white.svg";
import SpeedImgWhite from "Assets/Images/trfficAnalysis/camera/white/speed-white.svg";
import LaneImgWhite from "Assets/Images/trfficAnalysis/camera/white/lane-white.svg";
import BusImgWhite from "Assets/Images/trfficAnalysis/camera/white/bus-white.svg";

export const STATIONS: IStationData[] = [
  { type: "bus", text: "اتوبوس", icon: <Icon icon="directions_bus" /> },
  { type: "metro", text: "مترو", icon: <Icon icon="directions_transit" /> },
  { type: "taxi", text: "تاکسی", icon: <Icon icon="local_taxi" /> },
  { type: "train", text: "قطار", icon: <Icon icon="train" /> },
  { type: "bicycle", text: "دوچرخه", icon: <Icon icon="pedal_bike" /> },
  { type: "walking", text: "پیاده", icon: <Icon icon="directions_walk" /> },
  {
    type: "behamrah",
    text: "بهمراهی",
    icon: <Icon img="/assets/behamrah-logo.svg" imgProps={{ style: { height: "22px" } }} />,
  },
];

export const STATIONS2: IStationData[] = [
  { type: "bus", text: "اتوبوس", icon: <Icon icon="directions_bus" iconProps={{ style: { fontSize: "30px", zIndex: "3" } }} /> },
  {
    type: "metro",
    text: "مترو",
    icon: <Icon icon="directions_transit" iconProps={{ style: { fontSize: "30px", zIndex: "3" } }} />,
  },
  { type: "taxi", text: "تاکسی", icon: <Icon icon="local_taxi" iconProps={{ style: { fontSize: "30px", zIndex: "3" } }} /> },
  { type: "train", text: "قطار", icon: <Icon icon="train" iconProps={{ style: { fontSize: "30px", zIndex: "3" } }} /> },
  { type: "bicycle", text: "دوچرخه", icon: <Icon icon="pedal_bike" iconProps={{ style: { fontSize: "30px", zIndex: "3" } }} /> },
  {
    type: "walking",
    text: "پیاده",
    icon: <Icon icon="directions_walk" iconProps={{ style: { fontSize: "30px", zIndex: "3" } }} />,
  },
  {
    type: "behamrah",
    text: "بهمراهی",
    icon: <Icon img="/assets/behamrah-logo.svg" imgProps={{ style: { height: "22px", zIndex: "2" } }} />,
  },
];

export const STATIONS3: IStationData[] = [
  { type: "bus", text: "سرویس ها", icon: <Icon icon="directions_bus" /> },
  { type: "metro", text: "آزاد", icon: <Icon icon="directions_transit" /> },
  { type: "taxi", text: "تاکسی خطی", icon: <Icon icon="local_taxi" /> },
  { type: "train", text: "همپیمایی", icon: <Icon icon="train" /> },
  { type: "bicycle", text: "دربستی", icon: <Icon icon="pedal_bike" /> },
  { type: "walking", text: "بیکار", icon: <Icon icon="directions_walk" /> },
  {
    type: "behamrah",
    text: "بهمراهی",
    icon: <Icon img="/assets/behamrah-logo.svg" imgProps={{ style: { height: "22px" } }} />,
  },
];

export const CAMERA_TYPES = [
  { type: "26", text: "پلاک خوان مسیر ویژه اتوبوس", imgSrc: BusImg, whiteImgSrc: BusImgWhite },
  { type: "22", text: "پلاک خوان بهشت زهرا", imgSrc: MortalityImg, whiteImgSrc: MortalityImgWhite },
  { type: "24", text: "پلاک خوان تاکسیرانی", imgSrc: TaxiImg, whiteImgSrc: TaxiImgWhite },
  { type: "29", text: "طرح ترافیک", imgSrc: TrafficImg, whiteImgSrc: TrafficImgWhite },
  { type: "32", text: "طرح کنترل الودگی", imgSrc: PollutionImg, whiteImgSrc: PollutionImgWhite },
  { type: "28", text: "ثبت تخلف سرعت", imgSrc: SpeedImg, whiteImgSrc: SpeedImgWhite },
  { type: "20", text: "ثبت تخلف چراغ قرمز", imgSrc: RedlightImg, whiteImgSrc: RedlightImgWhite },
  { type: "27", text: "پلاک خوان لاین اضطرار", imgSrc: LaneImg, whiteImgSrc: LaneImgWhite },
  { type: "21", text: "پلاک خوان تره بار", imgSrc: VegetablesImg, whiteImgSrc: VegetablesImgWhite },
  { type: "30", text: "پلاک خوان رینگ تهران", imgSrc: RingImg, whiteImgSrc: RingImgWhite },
];

export const TRAFFIC_TYPES = [
  { type: "1", text: "شخصی", imgSrc: CarImg, whiteImgSrc: CarImgWhite },
  { type: "3", text: "خطی", imgSrc: TaxiImg, whiteImgSrc: TaxiImgWhite },
  { type: "2", text: "گردشی", imgSrc: TaxifreeImg, whiteImgSrc: TaxifreeImgWhite },
  { type: "4", text: "تلفنی", imgSrc: CalltaxiImg, whiteImgSrc: CalltaxiImgWhite },
  { type: "5", text: "تاکسی اینترنتی", imgSrc: MobileImg, whiteImgSrc: MobileImgWhite },
  { type: "6", text: "ناوگان باری", imgSrc: TruckImg, whiteImgSrc: TruckImgWhite },
];
